import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className="header">
            <img src="https://www.bdtask.com/assets/images/bdtask-logo.png" alt="" />
            <h2>Bdtask A Leading Software Company</h2>
            <p>Bdtask Limited is one of the best and leading innovative software developing company in Bangladesh. </p>
        </div>
    );
};

export default Header;